import { createSelector } from 'reselect';
import { LocationType } from 'types';

const localState = ({ search }) => search;

export const getSearchCriteriaSelector = createSelector(localState, ({ search }) =>
  Object.entries(search).reduce((acc, [key, val]) => {
    if (val) return { ...acc, [key]: val };
    return { ...acc };
  }, {}),
);

export const getSearchIsMapDrawingModeSelector = createSelector(
  localState,
  (state) => state.areaDrawing.isEnabled,
);

export const getSearchDrawnPolygonSelector = createSelector(
  localState,
  (state) =>
    state.search?.Locations?.filter((loc) => loc.Type === LocationType.Polygon)?.Polygon ?? null,
);
